"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.entitiesToMap = entitiesToMap;
exports.keyIn = keyIn;
exports.orderedMapReviver = void 0;
var _immutable = _interopRequireDefault(require("immutable"));
var _get = _interopRequireDefault(require("lodash/get"));
// Custom immutable reviver to ensure JS Objects are stored as OrderedMap
const orderedMapReviver = (key, value) => _immutable.default.Iterable.isKeyed(value) ? value.toOrderedMap() : value.toList();
exports.orderedMapReviver = orderedMapReviver;
function keyIn(...keys) {
  // Use with Map.filter(keyIn(<keys>)) -- similar to _.pick()
  const keySet = _immutable.default.Set(keys);
  return (v, k) => keySet.has(k);
}
function entitiesToMap(entities, pkField) {
  return entities?.reduce((acc, item) => {
    // this is a workaround to support endpoints that don't follow API guidelines
    if (typeof item === 'string') {
      return acc.set(item, _immutable.default.fromJS({
        id: item
      }, orderedMapReviver));
    }
    return acc.set((0, _get.default)(item, pkField)?.toString(), _immutable.default.fromJS(item, orderedMapReviver));
  }, _immutable.default.OrderedMap());
}